import { differenceWith, pipe, map, propEq } from 'ramda'

export const optionComparator = (obj1, obj2) => obj1.label === obj2.label

export const makeOption = ({ label, value }) => ({ value: value || label, label })

export const makeOptions = pipe(
  differenceWith(optionComparator),
  map(makeOption)
)

export const valueEquals = propEq('value')
